module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag04_0148AT.61aac475.jpg";